import type { WineResult } from '../types/wine.types'
import WineResultDisplay from './WineResult'

interface WineLookupProps {
  vintages: string[]
  regions: string[]
  selectedVintage: string
  selectedRegion: string
  result: WineResult | null
  onVintageChange: (vintage: string) => void
  onRegionChange: (region: string) => void
  onLookup: () => void
}

function WineLookup({
  vintages,
  regions,
  selectedVintage,
  selectedRegion,
  result,
  onVintageChange,
  onRegionChange,
  onLookup
}: WineLookupProps) {
  const canLookup = selectedVintage && selectedRegion

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-light text-gray-800 mb-4">Find a Wine</h2>
      <p className="text-gray-600 mb-6">
        Select a vintage and region to see if the wine growing conditions were favorable.
      </p>

      <div className="space-y-4">
        <div>
          <label htmlFor="vintage" className="block text-sm font-medium text-gray-700 mb-1">
            Select Vintage
          </label>
          <select
            id="vintage"
            value={selectedVintage}
            onChange={(e) => onVintageChange(e.target.value)}
            className="select-field"
          >
            <option value="">-- Select Vintage --</option>
            {vintages.map((vintage) => (
              <option key={vintage} value={vintage}>
                {vintage}
              </option>
            ))}
          </select>
        </div>

        {selectedVintage && (
          <div>
            <label htmlFor="region" className="block text-sm font-medium text-gray-700 mb-1">
              Select Region
            </label>
            <select
              id="region"
              value={selectedRegion}
              onChange={(e) => onRegionChange(e.target.value)}
              className="select-field"
            >
              <option value="">-- Select Region --</option>
              {regions.map((region) => (
                <option key={region} value={region}>
                  {region}
                </option>
              ))}
            </select>
          </div>
        )}

        <button
          onClick={onLookup}
          disabled={!canLookup}
          className="btn-primary w-full mt-4"
        >
          Lookup Wine
        </button>

        {result && <WineResultDisplay result={result} />}
      </div>
    </div>
  )
}

export default WineLookup
